import React ,{useEffect , useState} from 'react'
import { CommonCharts } from '../CommonCharts/CommonCharts';
import Commonrecords from '../Commonrecords/Commonrecords';
import { useDispatch, useSelector } from "react-redux";
import {clearInternalSupportRegionalChart ,
  clearInternalSupportRegionalList
  } from "../../../../../../../../Redux/Slice"


export const RegionalTabsdetails = ({
     datas,
  PriorityValues,
  SttausValues,
  Client,
  date, 
  range,
  Client_id
}) => {
    const state = useSelector((state) => state);
     const dispatch = useDispatch();
       const [search, setSearch] = useState("");


     const regionalListed = useSelector((state)=>state.InternalSupportRegionalList.internalSupportRegionalListData)
     const regional_charts = useSelector((state)=>state.InternalSupportRegionalChart.internalSupportRegionalChartData)


let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");


 useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                zone: datas.zone,
                department:Client,
             region: datas.region,
                    date:date,
                 search:search,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,

                            state:datas.state,
         client:Client_id

                      }
         dispatch(clearInternalSupportRegionalList(payload))
    }
    },[datas  ,Client  ,PriorityValues , search ,date, range])


    useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                zone: datas.zone,
                region: datas.region,

                department:Client,
                                  date:date,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
                                  state:datas.state,

          client:Client_id

              
              }
         dispatch(clearInternalSupportRegionalChart(payload))
    }
    },[datas  ,Client  ,PriorityValues ,date, range,Client_id ])



const regionalData = regional_charts.map(item => ({
value: item.ticket_percentage != null
  ? parseFloat(item.ticket_percentage.toFixed(2))
  : 0,
  name: item.region_id__region_name.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) // Proper Case
}));


const regionalIssues = regionalListed.map((item) => ({
  id: item.region_id__id,
  name: item.region_id__region_name,
  count: item.group_tickets,
}));



  return (
    <>
    <div className="chart-list-row_state">

  <div className="Chart_design">

        <CommonCharts title="Top 5 Issue Regional" data={regionalData} 
               />
      </div>

<div className="Listed_datas">

  <Commonrecords allIssues={regionalIssues}  title={"Regional List"} 
  
    search={search} setSearch={setSearch}
  Table_names={"region"}

  />

</div>
    </div>

    </>
  )
}
